import { render, staticRenderFns } from "./LotOption.vue?vue&type=template&id=10a747ae&scoped=true&"
import script from "./LotOption.vue?vue&type=script&lang=js&"
export * from "./LotOption.vue?vue&type=script&lang=js&"
import style0 from "./LotOption.vue?vue&type=style&index=0&id=10a747ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a747ae",
  null
  
)

export default component.exports